<mat-card>
    <mat-card-header>
        <div style="width: 64px; height: 64px;" mat-card-avatar >
            <app-avatar 
                [src]="script.author.avatar" 
                alt=""
                ></app-avatar>
        </div>
        <mat-card-title style="width: calc(100% - 1rem);">
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                {{ script.title }}
                @if (!hideStatus) {
                    <mat-chip-listbox>
                    @for (icon of scriptService.getStatusText(script).icon; track $index) {
                        <mat-chip>
                            <app-icon matChipAvatar [icon]="icon.icon" style="margin-left: 0.5rem;" [matTooltip]="icon.tooltip"></app-icon>
                            {{ icon.tooltip }}
                        </mat-chip>
                    }
                    </mat-chip-listbox>
                }
            </div>
        </mat-card-title>
        <mat-card-subtitle>by {{ script.author.name }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        @if (script.contentPreview) {
            <div class="content-preview">
                <p class="preview-text" [innerHTML]="highlightSearchTerm(script.contentPreview, searchQuery)"></p>
            </div>
        }
        <div style="display: flex; flex-direction: column; gap: 4px; margin-top: 1rem;">
            @if (script.viewCount !== undefined && script.viewCount > 0) {
                <span><app-icon icon="visibility"></app-icon> {{ script.viewCount }} views</span>
            }
            
            @if (script.ratingAverage !== undefined && script.ratingCount !== undefined && script.ratingCount > 0) {
                <span><app-icon icon="star"></app-icon> {{ script.ratingAverage | number:'1.1-1' }}</span>
            }
        </div>
        
        <!-- Content projection for additional content (like admin status chips) -->
        <ng-content></ng-content>
        
    </mat-card-content>
</mat-card>